import { cn } from "src/utilities/shadcnUtils";

export const Bullet = ({ className }: { className?: string }) => {
  return <div className={cn("h-[5px] w-[5px] rounded-full bg-gray mt-[1px]", className)} />;
};
